import { render } from "./CookiesTabs.vue?vue&type=template&id=72da6d67&scoped=true&ts=true"
import script from "./CookiesTabs.vue?vue&type=script&lang=ts"
export * from "./CookiesTabs.vue?vue&type=script&lang=ts"

import "./CookiesTabs.vue?vue&type=style&index=0&id=72da6d67&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72da6d67"]])

export default __exports__